// extracted by mini-css-extract-plugin
export const root = "dialog-button-module--root--UREdU";
export const buttonRoot = "dialog-button-module--button-root--EQxI_";